import script from "./insurance-refund-word.vue?vue&type=script&lang=ts&setup=true"
export * from "./insurance-refund-word.vue?vue&type=script&lang=ts&setup=true"

import "./insurance-refund-word.vue?vue&type=style&index=0&id=4c70e1f6&scoped=true&lang=scss"

import exportComponent from "/var/lib/jenkins/workspace/qiyexinxi_app-after-sales_prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4c70e1f6"]])

export default __exports__